/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BadRequestResponse,
  FailureResponseResponse,
  ForbiddenResponse,
  GetAccountingLocationsParams,
  GetAccountingLocationsResponseResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Get a list of all Accounting Locations
 */
export const getAccountingLocations = (
  params?: GetAccountingLocationsParams,
  signal?: AbortSignal,
) => {
  return customInstance<GetAccountingLocationsResponseResponse>({
    url: `/bm-accounting-location/v1/`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetAccountingLocationsQueryKey = (params?: GetAccountingLocationsParams) => {
  return [`/bm-accounting-location/v1/`, ...(params ? [params] : [])] as const;
};

export const getGetAccountingLocationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccountingLocations>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | FailureResponseResponse
  >,
>(
  params?: GetAccountingLocationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAccountingLocations>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAccountingLocationsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountingLocations>>> = ({ signal }) =>
    getAccountingLocations(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAccountingLocations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAccountingLocationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccountingLocations>>
>;
export type GetAccountingLocationsQueryError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | FailureResponseResponse
>;

/**
 * @summary Get a list of all Accounting Locations
 */
export const useGetAccountingLocations = <
  TData = Awaited<ReturnType<typeof getAccountingLocations>>,
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | FailureResponseResponse
  >,
>(
  params?: GetAccountingLocationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAccountingLocations>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAccountingLocationsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
